import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useState } from "react";

function EmailBanner({
  devPort,
  userName,
  managerMode,
}: {
  devPort: string;
  userName: string;
  managerMode: number;
}) {
  const [userEmail, setUserEmail] = useState("TOPROCESS");
  const navigate = useNavigate();

  const getUserEmail = useCallback(() => {
    const fetchUserEmail = devPort + "system_get_user_email/" + userName;
    fetch(fetchUserEmail, { credentials: "include" })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((data) => {
        console.log("getUserEmail");
        console.log(data);
        if (data[0][0]) {
          setUserEmail(data[0][0]);
        } else {
          setUserEmail("");
        }
      });
  }, [devPort, userName]);

  useEffect(() => {
    getUserEmail();
  }, [devPort, userName, getUserEmail]);

  if (userEmail) {
    return null;
  }
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      data-testid="missing-email-banner"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => navigate("/user-settings")}
        >
          Go to Settings
        </Button>
      }
    >
      Your email address is missing.Enter it to stay updated
      {managerMode !== -1 ? " and to allow your manager to contact you. " : ". "}
      Please update your profile in settings.
    </Alert>
  );
}

export default EmailBanner;
